export const time: Date = new Date(process.env.BUILD_TIME || 0);
export const version: string = (process.env.BUILD_VERSION || 'test');

// Define info globally
if (window['~hpe~']) {
  Object.assign(window['~hpe~'], {time, version});
}
